import { CreateTeamDto, Team, UpdateTeamDto } from 'shared/interfaces/Team';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const teamBaseEndpoint = '/team';

export const TeamService = {
  getAllTeams: async (): Promise<Team[]> => {
    const response = await axiosBaseInstance({
      method: 'GET',
      url: `${teamBaseEndpoint}/all`
    });

    return response.data;
  },

  getOwnedTeams: async (): Promise<Team[]> => {
    const response = await axiosBaseInstance({
      method: 'GET',
      url: `${teamBaseEndpoint}/owned`
    });

    return response.data;
  },

  getMemberTeams: async (): Promise<Team[]> => {
    const response = await axiosBaseInstance({
      method: 'GET',
      url: `${teamBaseEndpoint}/member`
    });

    return response.data;
  },

  createTeam: async (createTeamDto: CreateTeamDto): Promise<Team> => {
    const response = await axiosBaseInstance({
      method: 'POST',
      url: `${teamBaseEndpoint}`,
      data: createTeamDto
    });

    return response.data;
  },

  updateTeam: async (teamId: string, updateTeamDto: UpdateTeamDto): Promise<Team> => {
    const response = await axiosBaseInstance({
      method: 'PUT',
      url: `${teamBaseEndpoint}/${teamId}`,
      data: updateTeamDto
    });

    return response.data;
  },

  deleteTeam: async (teamId: string): Promise<Team> => {
    const response = await axiosBaseInstance({
      method: 'DELETE',
      url: `${teamBaseEndpoint}/${teamId}`
    });

    return response.data;
  }
};
